export default __webpack_public_path__ + "static/media/pencils.80cfe474.png";